import { Column, WaitingRoomView } from "src/api/types";
import { format } from "date-fns";

export const columns: readonly Column<WaitingRoomView>[] = [
  {
    id: "status",
    label: "Status",
    minWidth: 20,
    align: "center",
    orderable: false,
    format: (value) => value.status ?? "N/A",
  },
  {
    id: "id",
    label: "Waiting Room ID",
    minWidth: 20,
    align: "center",
    orderable: true,
    orderBy: "id",
    format: (value) => value.id.toString(),
  },
  {
    id: "patient_id",
    label: "Patient ID",
    minWidth: 20,
    align: "center",
    orderable: true,
    orderBy: "patient_id",
    format: (value) => value.patient_id?.toString() ?? "N/A",
  },
  {
    id: "patient_name",
    label: "Patient",
    minWidth: 20,
    align: "center",
    orderable: false,
    format: (value) =>
      `${value.patient_first_name ?? "N/A"} ${
        value.patient_last_name ?? "N/A"
      }`,
  },
  {
    id: "created_at",
    label: "Room Creation Date",
    minWidth: 50,
    align: "center",
    orderable: true,
    orderBy: "created_at",
    format: (value) => format(new Date(value.created_at || ""), "MM/dd/yyyy"),
  },
  {
    id: "assignee",
    label: "Assignee ",
    minWidth: 50,
    align: "center",
    orderable: false,
    format: (value) =>
      `${value.assignee_first_name ?? ""} ${value.assignee_last_name ?? ""}`,
  },
  {
    id: "queue",
    label: "Queue Type",
    minWidth: 50,
    align: "center",
    orderable: false,
    format: (value) => {
      if (value.queue === "Coordinator") {
        return "Health Navigator";
      }

      return value.queue ?? "N/A";
    },
  },
];
